<template>
    <div>
        <agile :options="options">
            <div
                v-for="link in links"
                :key="link"
            >
                <img
                    v-if="link != links[3]"
                    class="block w-full lg:h-150 md:h-100 h-60 object-cover object-center"
                    :src="link"
                >
                <img
                    v-else
                    class="block w-full lg:h-150 md:h-100 h-60 object-cover object-bottom"
                    :src="link"
                >
                <!-- <img
                    class="block w-full lg:h-150 md:h-100 h-60 object-contain"
                    :src="link"
                > -->
            </div>
            <template slot="prevButton">
                <div class="flex items-center justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M15 19l-7-7 7-7"
                        />
                    </svg>
                </div>
            </template>
            <template slot="nextButton">
                <div class="flex items-center justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 5l7 7-7 7"
                        />
                    </svg>
                </div>
            </template>
        </agile>
    </div>
</template>
<script>
import { VueAgile } from 'vue-agile';

export default {
    components: {
        agile: VueAgile,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/full/dentalfit_15_a.jpg' ),
                require( '@/assets/img/full/sozialschnellgut_1_a.jpg' ),
                require( '@/assets/img/full/DSC_4442.jpg' ),
                require( '@/assets/img/full/_DSC1287.jpg' ),
            ],
            options: {
                autoplay: true,
                autoplaySpeed: 5000,
            },
        };
    },
    methods: {},
    created () { },
};
</script>

<style lang="css">
.agile__nav-button {
    background: transparent;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 24px;
    height: 100%;
    position: absolute;
    top: 0;
    transition-duration: 0.3s;
    width: 80px;
}
.agile__nav-button:hover {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
}
.agile__nav-button--prev {
    left: 0;
}
.agile__nav-button--next {
    right: 0;
}
.agile__dots {
    bottom: 10px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
}
.agile__dot {
    margin: 0 10px;
}
.agile__dot button {
    background-color: transparent;
    border: 1px solid #fff;
    border-radius: 50%;
    cursor: pointer;
    display: block;
    height: 10px;
    font-size: 0;
    line-height: 0;
    margin: 0;
    padding: 0;
    transition-duration: 0.3s;
    width: 10px;
}
.agile__dot--current button,
.agile__dot:hover button {
    background-color: #fff;
}
</style>